import React from 'react'
import ReactDOM from 'react-dom'
import '../vendor/sentry'
import App from '../App'
import config from '../config'
import canny from '../vendor/canny'

// bootstrap
import { initializeLaunchDarkly } from '../featureFlags'

initializeLaunchDarkly().finally(() => {
  ReactDOM.render(<App />, document.getElementById('root'))
})

if (config.user.role === 'admin' && import.meta.env.MODE === 'production') {
  canny()
}
